var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"excelBtn",attrs:{"type":"button"},on:{"click":_vm.onCreateExcel}},[_c('span',{staticClass:"sp_ico excel right"}),_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }